import * as React from 'react';
import { styled, Grid, Switch } from '@material-ui/core';
import { brand } from '../../theme';

const LOTTO_LOCO_FIELD_STYLE_ID = "lotto-loco-field-keyframes";
const LOTTO_LOCO_FIELD_KEYFRAMES = `
@keyframes lottoLocoSparkle { 0%, 100% { transform: scale(1) rotate(0); opacity: 0.7; } 50% { transform: scale(1.3) rotate(15deg); opacity: 1; } }
`;

/** Inject the @keyframes once at runtime. JSS-scoped keyframes don't help
 *  the cross-component sparkle styles below, so we use a global stylesheet
 *  with a guarded id so it only injects once even if the component mounts
 *  in multiple places. */
const ensureLottoLocoFieldKeyframes = () => {
    if (typeof document === "undefined") return;
    if (document.getElementById(LOTTO_LOCO_FIELD_STYLE_ID)) return;
    const tag = document.createElement("style");
    tag.id = LOTTO_LOCO_FIELD_STYLE_ID;
    tag.textContent = LOTTO_LOCO_FIELD_KEYFRAMES;
    document.head.appendChild(tag);
};

export const LottoLocoField = styled(({ checked, onChange, className, ...p }: any) => {
    React.useEffect(ensureLottoLocoFieldKeyframes, []);
    return (
        <Grid item className={className}>
            <div className={`row${checked ? ' row--on' : ''}`}>
                {checked && (
                    <>
                        <span className="sparkle sparkle--a" aria-hidden>✦</span>
                        <span className="sparkle sparkle--b" aria-hidden>✦</span>
                    </>
                )}
                <div className="badge" aria-hidden>🎰</div>
                <div className="copy">
                    <div className="title-row">
                        <div className="title">{checked ? 'LOTTO LOCO' : 'Lotto Loco'}</div>
                        <span className="new-pill">NEW</span>
                    </div>
                    <div className="subtitle">
                        Tasters can let the system randomly pick all their beers in one tap.
                    </div>
                </div>
                <Switch
                    checked={Boolean(checked)}
                    onChange={(event) =>
                        onChange && onChange({ lottoLocoEnabled: event.target.checked })
                    }
                    inputProps={{ "data-testid": "lottoLocoEnabled" } as any}
                    name="lottoLocoEnabled"
                    color="primary"
                    {...p}
                />
            </div>
        </Grid>
    );
})(({ theme }) => ({
    marginTop: theme.spacing(2),
    "& .row": {
        position: "relative",
        overflow: "hidden",
        background: brand.white,
        border: `1.5px solid ${brand.sep}`,
        borderRadius: 14,
        padding: theme.spacing(1.75, 1.75),
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1.5),
        transition: "all .25s",
    },
    "& .row--on": {
        background: `linear-gradient(135deg, ${brand.amberDark} 0%, #2D1F08 100%)`,
        border: `1.5px solid ${brand.amber}66`,
    },
    "& .sparkle": {
        position: "absolute",
        color: brand.amber,
        animation: "lottoLocoSparkle 2.4s ease-in-out infinite",
        pointerEvents: "none",
    },
    "& .sparkle--a": {
        top: 8,
        right: 64,
        fontSize: 9,
        opacity: 0.6,
    },
    "& .sparkle--b": {
        bottom: 10,
        right: 96,
        fontSize: 7,
        opacity: 0.4,
        animationDuration: "1.8s",
    },
    "& .badge": {
        width: 42,
        height: 42,
        borderRadius: 11,
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#EDE8E0",
        fontSize: 22,
        filter: "grayscale(1) opacity(0.5)",
        transition: "all .25s",
    },
    "& .row--on .badge": {
        background: `linear-gradient(135deg, ${brand.amber} 0%, ${brand.amberDeep} 100%)`,
        boxShadow: `0 4px 14px ${brand.amber}66`,
        filter: "none",
    },
    "& .copy": {
        flex: 1,
        minWidth: 0,
        position: "relative",
        zIndex: 1,
    },
    "& .title-row": {
        display: "flex",
        alignItems: "center",
        gap: 6,
    },
    "& .title": {
        fontSize: 14,
        fontWeight: 800,
        color: brand.text,
        letterSpacing: 0,
    },
    "& .row--on .title": {
        color: brand.amber,
        letterSpacing: 0.3,
    },
    "& .new-pill": {
        fontSize: 8,
        fontWeight: 800,
        color: brand.amberDark,
        background: brand.amber,
        padding: "2px 5px",
        borderRadius: 3,
        letterSpacing: 0.6,
    },
    "& .subtitle": {
        fontSize: 11,
        color: brand.textSec,
        marginTop: 2,
        lineHeight: 1.4,
    },
    "& .row--on .subtitle": {
        color: "#C4B8A8",
    },
}));
